<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/YX4AUT/tc-custom/9781591812265.jpg?1726339886203" alt="This image is the cover for the book Why Lazarus Laughed"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Why Lazarus Laughed
      </h1>
      <p class="bookDescription body article font2">
        <p>Why Lazarus Laughed explicates the essential doctrine shared by the traditions of Zen Buddhism, Advaita, and Tantra. Wei Wu Wei has become an underground spiritual favorite whose fans anxiously await each reissued book.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Wei Wu Wei
      </h2>
      
      <p class="authorDescription body article">“Wei Wu Wei” was born in 1895 into a well-established Irish family, was raised on an estate outside Cambridge, England, and received a thorough education, including studies at Oxford University. Early in life he pursued an interest in Egyptology, which culminated in the publication of two books on ancient Egyptian history and culture in 1923. This was followed by a period of involvement in the arts in Britain in the 20’s and 30’s as a theorist, theatrical producer, creator of radical “dance-dramas,” publisher of several related magazines, and author of two related books.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Sentient Publications
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1859356c